import { create } from 'zustand';

interface AppState {
  // Online/offline connectivity
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;

  // Sidebar collapsed state
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleSidebar: () => void;

  // Global loading overlay (for heavy async ops like institution impersonation)
  globalLoading: boolean;
  setGlobalLoading: (loading: boolean) => void;

  // Notification panel open
  notificationPanelOpen: boolean;
  setNotificationPanelOpen: (open: boolean) => void;

  // StudentAssist panel open (student-facing)
  studentAssistOpen: boolean;
  setStudentAssistOpen: (open: boolean) => void;

  // Active assignment context for StudentAssist
  activeAssignmentContext: ActiveAssignmentContext | null;
  setActiveAssignmentContext: (ctx: ActiveAssignmentContext | null) => void;
}

export interface ActiveAssignmentContext {
  type: string;
  id: string;
  title: string;
  screenContext?: string; // Rich description of what the student currently sees
}

export const useAppStore = create<AppState>((set) => ({
  isOnline: navigator.onLine,
  setIsOnline: (isOnline) => set({ isOnline }),

  sidebarCollapsed: false,
  setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  globalLoading: false,
  setGlobalLoading: (globalLoading) => set({ globalLoading }),

  notificationPanelOpen: false,
  setNotificationPanelOpen: (notificationPanelOpen) => set({ notificationPanelOpen }),

  studentAssistOpen: false,
  setStudentAssistOpen: (studentAssistOpen) => set({ studentAssistOpen }),

  activeAssignmentContext: null,
  setActiveAssignmentContext: (activeAssignmentContext) => set({ activeAssignmentContext }),
}));
